import React from 'react';
import {Link, useCart, useLocalization} from '@shopify/hydrogen';
import type {Product as ProductType} from '@shopify/hydrogen/storefront-api-types';
import * as R from 'ramda';
import clsx from 'clsx';
import Product from '../custom/Product.client';
import FrequentlyBoughtTogether from '../custom/FrequentlyBoughtTogether.client';

// @ts-expect-error
import {Swiper, SwiperSlide} from 'swiper/react';
// @ts-expect-error
import {Swiper as SwiperClass} from 'swiper/types';

export default function CartFBT() {
  const {
    language: {isoCode: languageCode},
    country: {isoCode: countryCode},
  } = useLocalization();
  const {lines} = useCart();
  const firstProductId =
    lines &&
    !R.isEmpty(lines) &&
    (lines[0].merchandise.product as ProductType).id;

  const [products, setProducts] = React.useState<ProductType[]>([]);

  const getRecommendation = async () => {
    try {
      const res = await fetch('/api/cart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({gid: firstProductId, countryCode, languageCode}),
      });
      const data = await res.json();
      await setProducts(data.data.productRecommendations);
    } catch (error) {
      console.log(error);
    }
  };

  const [activeIndex, setActiveIndex] = React.useState(0);
  const carouselRef = React.useRef<SwiperClass>(null);

  React.useEffect(() => {
    if (firstProductId) {
      getRecommendation();
    }
  }, [lines]);

  const hasSlides = products && !R.isEmpty(products);
  const lastIndex = hasSlides && products.length - 3;
  const SwiperCarousel: SwiperClass = Swiper;

  if (hasSlides) {
    return (
      <div className="mt-10">
        <div className="mb-10">
          <FrequentlyBoughtTogether
            frequentlyBoughtTogetherProducts={products}
            type="cart"
            title="Freguently Bought Together"
            button_label="Add To Cart"
            total_price_label="Price"
          />
        </div>
      </div>
    );
  }
  return null;
}
